<template>
    <div>
        <span :class="'badge badge-' + badgeType">
            {{ $t('orders.components.OrderStatusBadge.' + status) }}
        </span>
    </div>
</template>

<script>
    export default {
        name: 'OrderStatusBadge',
        props: {
            status: {
                type: String,
                required: true,
            },
        },

        data() {
            return {
                badgeType: 'info',
            };
        },

        created() {
            this.renderBadge(this.status);
        },

        methods: {
            renderBadge(status)
            {
                switch (status) {
                case 'PLANNED':
                case 'IN_PROGRESS':
                    this.badgeType = 'info';
                    break;
                case 'COMPLETED':
                case 'ACCEPTED':
                    this.badgeType = 'success';
                    break;
                case 'CANCELLED_BY_CLIENT':
                case 'CANCELLED':
                    this.badgeType = 'danger';
                    break;
                default:
                    this.badgeType = 'primary';
                }
            },
        },
    };
</script>
